<div>
  <app-main-heading>
    <span title>{{ "HELPFAQ.FAQ" | translate }}</span>
  </app-main-heading>
</div>

<div class="relative row mt-3">
  <div class="col-12">
    <div class="d-none d-md-block">
      <div class="d-flex align-items-start mb-5">
        <div class="">
          <nav id="sidebar">
            <div
              class="left-0 d-block fixed top-0 bottom-0 overflow-y-auto flex-row flex-nowrap overflow-hidden flex-column align-items-stretch px-0 d-flex flex-wrap align-items-center justify-content-between">
              <ul class="flex-column min-w-100 d-flex list-unstyled me-4 faq-pills" id="pills-tabVertical">
                <li *ngFor="let item of tabsData; let i = index" (click)="selectedIndex(i, item)"
                  class="align-items-center q-vertical-text cursor-pointer"
                  [ngClass]="selectedI == i ? 'active' : 'inactive'" data-toggle="tooltip" i18n-title
                  title="{{ item.tabsName | translate }}">
                  <span class="overflow-txt">
                    {{ item.tabsName }}
                  </span>
                </li>
              </ul>
            </div>
          </nav>
        </div>

        <div class="p-4 q-vertical-content" [ngClass]="
                selectedI === 0
                  ? 'content-border-radius'
                  : 'rounded-border-radius'
              ">
          <ng-container *ngIf="selectedI === 0">
            <div class="d-flex">
              <div class="faqDesc">
                <h4 class="fw-bold">{{ "SIDEBAR.HELP&FAQ" | translate }}</h4>
                <p class="mb-0">
                  {{ "HELPFAQ.HOWCANIHELPYOU" | translate }}
                </p>
              </div>

              <div class="ms-auto d-flex justify-content-center align-items-center">
                <div class="relative">
                  <div class="input-group faq-inputgroup">
                    <span class="input-group-text bg-transparent border-end-0">
                      <img [src]="'HELPFAQ.SEARCHICONiMG'|translate" alt="" />
                    </span>
                    <input type="text" class="form-control border-start-0 ps-0 shadow-none"
                      placeholder="{{ 'HELPFAQ.SEARCHHERE' | translate }}" [(ngModel)]="searchText" />
                  </div>
                </div>
              </div>
            </div>
            <div class="accordion mt-5 faq-accordion" id="accordionExample">
              <div *ngFor="
                      let task of tasksData | filter: searchText;
                      let i = index
                    " class="accordion-item bg-white mb-3">
                <div class="accordion-header mb-0" id="headingOne{{ i }}">
                  <button [ngClass]="
                          selectedIn == i
                            ? 'accordion-button shadow-none  relative p-4 bg-white border-0'
                            : 'accordion-button shadow-none collapsed relative p-4 bg-white border-0'
                        " type="button" data-bs-toggle="collapse" attr.data-bs-target="#collapse_{{ i }}"
                    aria-expanded="false" attr.aria-controls="collapseOne{{ i }}" (click)="accBtnClicked(i)">
                    <span class="me-4">{{ task?.name }}</span>
                  </button>
                </div>
                <div id="collapse_{{ i }}" [ngClass]="
                        selectedIn == i
                          ? 'accordion-collapse collapse show'
                          : 'accordion-collapse collapse'
                      " attr.aria-labelledby="headingOne{{ i }}" data-bs-parent="#accordionExample">
                  <div class="accordion-body">
                    {{ task.description }}
                    <div>
                      {{task.description1}}
                    </div>
                    <span *ngIf="task.id==1">
                      <ul>
                        <li>
                          {{ task.subId1desc1 }}
                        </li>
                        <li>{{ task.subId1desc2 }}</li>
                        <li>{{ task.subId1desc3 }}</li>
                        <li class="mb-3">{{ task.subId1desc4 }}</li>

                        <li class="list-unstyled"><strong>{{ task.subId1desc5 }}</strong></li>
                        <li class="list-unstyled font-italic">{{ task.subId1desc6 }}</li>
                      </ul>
                    </span>
                    <span *ngIf="task.id==2">
                      <ul>
                        <li>
                          {{ task.subId1desc0}}
                        </li>
                        <li>
                          {{ task.subId1desc1 }}
                        </li>
                        <li class="list-unstyled" class="mb-3">
                          {{ task.subId1desc2 }}
                          <a href="https://metaprotect.quickheal.com/">
                            https://metaprotect.quickheal.com/ </a>
                        </li>
                        <li class="list-unstyled">{{ task.subId1desc3 }}</li>
                        <li class="list-unstyled">{{ task.subId1desc4 }}</li>
                      </ul>
                    </span>
                    <span *ngIf="task.id==3">
                      <ul class="list-unstyled">
                        <li>
                          {{ task.subId1desc1 }}
                        </li>
                        <li>{{ task.subId1desc2 }}</li>
                        <li>{{ task.subId1desc3 }}</li>
                        <li>{{ task.subId1desc4 }}</li>
                      </ul>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </ng-container>
          <ng-container *ngIf="selectedI === 1">
            <div class="d-flex">
              <div>
                <h4 class="fw-bold">{{ "HELPFAQ.Support" | translate }}</h4>
              </div>
            </div>
            <div class="row">


              <div class="col-12 col-xl-4">
                <app-support-card statSubtitle="{{ 'HELPFAQ.TELSUPTXT' | translate }}"
                  [statTitle]="'HELPFAQ.TELESUPPORTIMG' | translate"
                  description="{{ 'HELPFAQ.SUPPORTCALL' | translate }}"
                  buttontitle="{{ 'HELPFAQ.SHOWDETAILS' | translate }}">
                </app-support-card>
              </div>
              <div class="col-12 col-xl-4">
                <app-support-card statSubtitle="{{ 'HELPFAQ.WEBSUPTXT' | translate }}"
                  [statTitle]="'HELPFAQ.WEBSUPPORTIMG' | translate" description="{{ 'HELPFAQ.SUPPORTTKT' | translate }}"
                  buttontitle="{{ 'HELPFAQ.VISITWEB' | translate }}"></app-support-card>
              </div>
              <div class="col-12 col-xl-4">
                <app-support-card statSubtitle="{{ 'HELPFAQ.EMAILSUPTXT' | translate }}"
                  [statTitle]="'HELPFAQ.EMAILSUPPORTIMG' | translate"
                  description="{{ 'HELPFAQ.SUPPORTQUERY' | translate }}"
                  buttontitle="{{ 'HELPFAQ.SUBMITTKT' | translate }}"></app-support-card>
              </div>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
    <div class="d-block d-md-none">
      <div class="accordion mb-5 faq-accordion" id="accordionExample1">
        <div *ngFor="
            let item of tabsData;
            let i = index
          " class="accordion-item bg-white mb-3">
          <div class="accordion-header mb-0" id="headingOne{{ i }}">
            <button class="accordion-button shadow-none collapsed relative p-3 bg-white border-0" type="button"
              data-bs-toggle="collapse" attr.data-bs-target="#collapse_{{ i }}" aria-expanded="false"
              attr.aria-controls="collapseOne{{ i }}" (click)="selectedIndex(i, item)">
              <span class="me-4">
                {{ item.tabsName }}
              </span>
            </button>
          </div>
          <div id="collapse_{{ i }}" class="accordion-collapse collapse" attr.aria-labelledby="headingOne{{ i }}"
            data-bs-parent="#accordionExample1">
            <div class="accordion-body">

              <ng-container *ngIf="i === 0">
                <div class="faqDesc">
                  <h4 class="fw-bold">{{ "HELPFAQ.FAQ" | translate }}</h4>
                  <p class="mb-0">
                    {{ "HELPFAQ.HOWCANIHELPYOU" | translate }}
                  </p>
                </div>

                <div class="ms-auto my-3">
                  <div class="relative">
                    <div class="input-group faq-inputgroup">
                      <span class="input-group-text bg-transparent border-end-0">
                        <img [src]="'HELPFAQ.SEARCHICONiMG'|translate" alt="" />
                      </span>
                      <input type="text" class="form-control border-start-0 ps-0 shadow-none"
                        placeholder="{{ 'HELPFAQ.SEARCHHERE' | translate }}" [(ngModel)]="searchText" />
                    </div>
                  </div>
                </div>
                <div class="accordion faq-accordion" id="accordionExample2">
                  <div *ngFor="
                          let task of tasksData | filter: searchText;
                          let j = index
                        " class="accordion-item bg-white mb-3">
                    <div class="accordion-header mb-0" id="headingOne{{ j }}">
                      <button [ngClass]="
                              selectedIn == j
                                ? 'accordion-button shadow-none  relative p-4 bg-white border-0'
                                : 'accordion-button shadow-none collapsed relative p-4 bg-white border-0'
                            " type="button" data-bs-toggle="collapse" attr.data-bs-target="#collapse__{{ j }}"
                        aria-expanded="false" attr.aria-controls="collapseOne{{ j }}" (click)="accBtnClicked(j)">
                        <span class="me-4">{{ task?.name }}</span>
                      </button>
                    </div>

                    <div id="collapse__{{ j }}" [ngClass]="
                            selectedIn == j
                              ? 'accordion-collapse collapse show'
                              : 'accordion-collapse collapse'
                          " attr.aria-labelledby="headingOne{{ j }}" data-bs-parent="#accordionExample2">
                      <div class="accordion-body">
                        {{ task.description }}
                        <span *ngIf="task.id == 1">
                          <ul>
                            <li>
                              {{ task.subId1desc1 }}
                            </li>
                            <li>{{ task.subId1desc2 }}</li>
                            <li>{{ task.subId1desc3 }}</li>
                            <li>{{ task.subId1desc4 }}</li>
                            <li>{{ task.subId1desc5 }}</li>
                            <li>{{ task.subId1desc6 }}</li>
                          </ul>
                        </span>
                        <span *ngIf="task.id==2">
                          <ul>
                            <li>
                              {{ task.subId1desc0}}
                            </li>
                            <li>
                              {{ task.subId1desc1 }}
                            </li>
                            <li class="list-unstyled" class="mb-3">
                              {{ task.subId1desc2 }}
                              <a href="https://metaprotect.quickheal.com/">
                                https://metaprotect.quickheal.com/ </a>
                            </li>
                            <li class="list-unstyled">{{ task.subId1desc3 }}</li>
                            <li class="list-unstyled">{{ task.subId1desc4 }}</li>
                          </ul>
                        </span>
                        <span *ngIf="task.id==3">
                          <ul class="list-unstyled">
                            <li>
                              {{ task.subId1desc1 }}
                            </li>
                            <li>{{ task.subId1desc2 }}</li>
                            <li>{{ task.subId1desc3 }}</li>
                            <li>{{ task.subId1desc4 }}</li>
                          </ul>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </ng-container>
              <ng-container *ngIf="i === 1">
                <div class="d-flex">
                  <div>
                    <h4 class="fw-bold">{{ "HELPFAQ.Support" | translate }}</h4>
                    <p class="mb-0">{{ "HELPFAQ.SupportText" | translate }}</p>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12 col-xl-4">
                    <app-support-card statSubtitle="{{ 'HELPFAQ.WEBSUPTXT' | translate }}"
                      [statTitle]="'HELPFAQ.WEBSUPPORTIMG' | translate"
                      description="{{ 'HELPFAQ.SUPPORTTKT' | translate }}"
                      buttontitle="{{ 'HELPFAQ.VISITWEB' | translate }}"></app-support-card>
                  </div>
                  <div class="col-12 col-xl-4">
                    <app-support-card statSubtitle="{{ 'HELPFAQ.EMAILSUPTXT' | translate }}"
                      [statTitle]="'HELPFAQ.EMAILSUPPORTIMG' | translate"
                      description="{{ 'HELPFAQ.SUPPORTQUERY' | translate }}"
                      buttontitle="{{ 'HELPFAQ.SUBMITTKT' | translate }}"></app-support-card>
                  </div>
                  <div class="col-12 col-xl-4">
                    <app-support-card statSubtitle="{{ 'HELPFAQ.TELSUPTXT' | translate }}"
                      [statTitle]="'HELPFAQ.TELESUPPORTIMG' | translate"
                      description="{{ 'HELPFAQ.SUPPORTCALL' | translate }}"
                      buttontitle="{{ 'HELPFAQ.SHOWDETAILS' | translate }}">
                    </app-support-card>
                  </div>
                </div>
              </ng-container>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>